import { render, staticRenderFns } from "./InstagramPlatformIcon.vue?vue&type=template&id=27143304&scoped=true"
import script from "./InstagramPlatformIcon.vue?vue&type=script&lang=js"
export * from "./InstagramPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27143304",
  null
  
)

export default component.exports